<template>
  <div :class="['relative', 'h-60']">
    <!-- 飘带背景层 -->
    <InspiraWavyBackground />

    <!-- 内容层 -->
    <div :class="['flex items-center justify-center', 'page_view', 'absolute z-1 inset-0']">
      <!-- 大容器 -->
      <div :class="['grid lg:grid-flow-col grid-cols-2 lg:gap-0 gap-4']">
        <!-- 单列容器 -->
        <Motion
          v-for="(item, index) in infoData"
          :key="`${item.title}-${index}`"
          :class="['flex justify-center items-center', 'font-bold text-center']"
          :initial="{
            y: 20,
            opacity: 0,
            filter: `blur(1rem)`,
          }"
          :while-in-view="{
            y: 0,
            opacity: 1,
            filter: `blur(0rem)`,
          }"
          :transition="{
            duration: 1,
            delay: 0.5 * index,
          }"
          :in-view-options="{
            once: true,
          }"
        >
          <!-- 将文字和竖线包裹在同一个flex容器避免显示顺序错误 -->
          <div
            :class="[
              'flex flex-col items-center justify-center lg:gap-2',
              'overflow-auto',
              'text-shadow-lg',
            ]"
          >
            <!-- 文字容器 -->
            <p class="text-white lg:text-5xl text-3xl text-wrap break-all">
              {{ item.subTitle }}
            </p>
            <h3 class="text-primary lg:text-xl text-lg">{{ t(item.title) }}</h3>
          </div>
          <!-- 竖分隔线 -->
          <div
            v-if="index !== infoData.length - 1"
            :class="['w-0.5 h-14 hidden lg:flex lg:bg-default', 'mx-12']"
          />
        </Motion>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  /** 文本内容 */
  const infoData = [
    {
      title: 'page.index.businessData.foundedIn',
      subTitle: '1995',
    },
    {
      title: 'page.index.businessData.trucksNum',
      subTitle: '280+',
    },
    {
      title: 'page.index.businessData.warehousingNum',
      subTitle: '200,000m²+',
    },
    {
      title: 'page.index.businessData.partnerNum',
      subTitle: '26+',
    },
  ]
</script>
